import {
  Box,
  Divider,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SvgIcon,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { alpha } from "@mui/system/colorManipulator";
import TopNavSection from "./TopNavSection";
import MenuIcon from "@mui/icons-material/Menu";
import { useAppSelector } from "utils/hooks";
import { selectSideNavCollpased } from "redux/preferencesSlice";
import { SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from "../DrawerLayout";
import help_icon from "../../../assets/icons1/help_icon.svg";
import { usePopover } from "hooks/use-popover";
import { RouterLink } from "components/router-link";
import viewpaths from "global/constants/ViewPathConstants";
import CustomPopper from "global/components/CustomPopper/CustomPopper";
import ticket_icon from "../../../assets/icons1/help_center_icon.svg";
import EmailUsageChart from "./EmailUsageChart";

const TOP_NAV_HEIGHT = 64;

const menuItems = [
  // {
  //   href: "",
  //   icon: <img src={help_center_icon} />,
  //   label: "Help Center",
  //   condition: true,
  // },
  {
    href: `${viewpaths.ticketsViewPath}`,
    icon: <img src={ticket_icon} />,
    label: "Tickets",
    condition: true,
  },
];

interface CustomProps {
  onMobileNavOpen: () => void;
  sections?: any;
}

const TopNav = (props: CustomProps) => {
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"));
  const sideNavCollpased = useAppSelector(selectSideNavCollpased);
  const popover = usePopover<any>();

  const getMenuSection = () => {
    return (
      <>
        <Box>
          {menuItems.map(
            (item, index) =>
              item.condition && (
                <>
                  <ListItemButton
                    key={index}
                    href={item.href}
                    onClick={popover.handleClose}
                    sx={{
                      borderRadius: 1,
                      px: 1,
                      py: 1,
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                    LinkComponent={RouterLink || "div"}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>

                    <ListItemText
                      primary={
                        <Typography variant="subtitle2" fontWeight={500}>
                          {item.label}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                  {index !== menuItems.length - 1 && (
                    <Divider
                      sx={{
                        borderColor: "rgba(71, 85, 105, 0.25)",
                      }}
                    />
                  )}
                </>
              )
          )}
        </Box>
      </>
    );
  };

  return (
    <Box
      component="header"
      sx={{
        backdropFilter: "blur(6px)",
        backgroundColor: (theme) =>
          alpha(theme.palette.background.default, 0.8),
        position: "sticky",
        left: {
          lg: `${
            sideNavCollpased ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
          }px`,
        },
        top: 0,
        width: {
          lg: `calc(100% - ${
            sideNavCollpased ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
          }px)`,
        },
        zIndex: (theme) => theme.zIndex.appBar,
        borderBottom: "1px solid #7551D01A",
      }}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={2}
        sx={{
          minHeight: TOP_NAV_HEIGHT,
          px: 2,
        }}
      >
        <Stack alignItems="center" direction="row" spacing={2}>
          {!lgUp && (
            <IconButton onClick={props.onMobileNavOpen}>
              <SvgIcon>
                <MenuIcon />
              </SvgIcon>
            </IconButton>
          )}
          {smUp && <EmailUsageChart />}
        </Stack>
        <Stack alignItems="center" direction="row" spacing={3}>
          <Stack
            direction="row"
            spacing={0}
            alignItems="center"
            sx={{ cursor: "pointer" }}
            onClick={popover.handleOpen}
            ref={popover.anchorRef}
          >
            <img src={help_icon} height={"30px"} width={"auto"} />
            <Typography variant="body2" color="#475569">
              Help
            </Typography>
          </Stack>
          <Box
            sx={{
              height: "30px",
              width: "1px",
              backgroundColor: "#47556980",
            }}
          />
          <TopNavSection />
        </Stack>
      </Stack>
      <CustomPopper
        open={popover.open}
        anchorRef={popover.anchorRef.current}
        handleClose={popover.handleClose}
        children={getMenuSection()}
        width="11.25rem"
      />
    </Box>
  );
};

export default TopNav;
